import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Information} from '../../../model/information';
import {Observable} from 'rxjs';
import {InfoBlockComponent} from "../../../components/common/info-block/info-block.component";
import {SearchBarComponent} from "../../../components/common/search-bar/search-bar.component";
import {SearchPipe} from "../../../components/common/SearchPipe";

import {SpinnerComponent} from "../../../components/common/spinner/spinner.component";
import {NgbNav, NgbNavItem, NgbNavLink} from "@ng-bootstrap/ng-bootstrap";
import {StatePipe} from "../../../components/common/StatePipe";
import {InformationType} from "../../../model/InformationType";

@Component({
    selector: 'app-list-informations',
    templateUrl: './list-informations.component.html',
    imports: [
    InfoBlockComponent,
    SearchBarComponent,
    SearchPipe,
    SpinnerComponent,
    NgbNav,
    NgbNavLink,
    StatePipe,
    NgbNavItem
],
    styleUrls: ['./list-informations.component.css']
})
export class ListInformationsComponent {
  direct: Information[];
  pinned: Information[];
  history: Information[];
  infoTypeFilter: InformationType = InformationType.DIRECT;
  _infos: Information[];
  filteredInfos: Information[];

  @Input() search: string;

  @Output()
  toArchive = new EventEmitter<Information>();
  @Output()
  edit = new EventEmitter<Information>();
  @Output()
  toHistory = new EventEmitter<Information>();
  @Output()
  publish = new EventEmitter<Information>();

  @Input()
  set infos(i: Observable<Information[]>) {
    i.subscribe(infos => {
      this._infos = infos;
      this.direct = [];
      this.pinned = [];
      this.history = [];
      infos.forEach(info => {
        if (info.type === 'DIRECT') {
          this.direct.push(info);
        } else if (info.type === 'PINNED') {
          this.pinned.push(info);
        } else if (info.type === 'HISTORY') {
          this.history.push(info);
        }
      });
      this.changeInfoTypeFilter(this.infoTypeFilter);
    });
  }

  constructor() {
  }

  changeInfoTypeFilter($event: InformationType) {
    // Filter out infos on selected InformationType
    this.filteredInfos = this._infos.filter(i => {
      return i.type === $event;
    });
    this.search = '';
  }

  protected readonly InformationType = InformationType;
}
